exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reason-item {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.reason-item:hover{\r\n    background:#d3d3d3;\r\n}\r\n    .reason-item.selected {\r\n        background: #3f51b5\r\n    }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/members/edit-member-sheet/edit-member-sheet.css
// module id = 578
// module chunks = 0